export const newAccount = "/accounts/new";
export const newSupplier = "/sms-suppliers/new";

export const newSubAccount = "/sub-accounts/new";

